module.exports = __webpack_public_path__ + "static/media/C20-0696_250MamaSmile_Desktop_2396x1473.eb27d9b4.jpg";